<template>
  <div data-app>
    <v-card>
      <v-card-title>
        Ordered Items
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-radio-group v-model="selectedList" row>
            <template v-slot:label>
              <div>Select sales order list</div>
            </template>
            <v-radio label="Active" value="active" />
            <v-radio label="Contracted" value="contracted" />
            <v-radio label="Inactive" value="inactive" />
            <v-radio label="Lost" value="lost" />
          </v-radio-group>
        </v-row>
<b-row class="mb-3">
<b-col cols="12" md="3">
  <label for="start-date">Start date</label>
  <div class="d-flex align-items-center">
    <b-form-datepicker
      id="start-date"
      v-model="startDate"
      :max="endDate || null"
      start-weekday="1"
      calendar-width="80%"
      locale="en"
      class="mb-2 flex-grow-1"
      @context="messages['start_date'] = ''"
    />
    <v-icon
      small
      class="ml-2"
      @click="startDate = null"
      style="cursor: pointer;"
    >
      mdi-delete
    </v-icon>
  </div>
</b-col>

<b-col cols="12" md="3">
  <label for="end-date">End date</label>
  <div class="d-flex align-items-center">
    <b-form-datepicker
      id="end-date"
      v-model="endDate"
      :min="startDate || null"
      start-weekday="1"
      calendar-width="80%"
      locale="en"
      class="mb-2 flex-grow-1"
      @context="messages['end_date'] = ''"
    />
    <v-icon
      small
      class="ml-2"
      @click="endDate = null"
      style="cursor: pointer;"
    >
      mdi-delete
    </v-icon>
  </div>
</b-col>


  <b-col cols="12" md="3">
 <v-text-field
          v-model="searchTerm"
          append-icon="mdi-magnify"
          label="Public note"
          single-line
          hide-details
        />
  </b-col>

  <b-col cols="12" md="3">
<v-select
  v-model="statusFilter"
  :items="statuses"
  item-text="value"
  item-value="key"
  label="Status"
/>
  </b-col>

</b-row>
        <v-data-table
          :headers="headers"
          :items="salesOrders"
          :search="search"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:loading>
            <v-progress-circular
              indeterminate
              color="primary"
              size="32"
            />
          </template>

          <template v-slot:item.total_num_of_pcs="{ item }">
            {{ Number(item.total_num_of_pcs).toLocaleString() }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "OrderedItems",

  data() {
    return {
      search: "",
      loading: true,
      salesOrders: [],
      selectedList: "active",
          startDate: null,
    endDate: null,
    searchTerm: null,
    statusFilter: null,
    statuses: [],
    
      headers: [
        { text: "Reference", value: "reference" },
        { text: "Item name", value: "name" },
        { text: "Num of pcs", value: "total_num_of_pcs" },
      ],
    };
  },

  mounted() {

    this.fetchSalesOrders();

      ApiService.get("config")
    .then((response) => {
      const statuses = response.data.statuses.sales.salesOrder;

      this.rawStatuses = statuses; // save original

      this.filterStatuses(); // initial filter
    })
    .catch((error) => {
      console.error("Error fetching statuses:", error);
    });
  },

  methods: {
   fetchSalesOrders() {
    this.loading = true;

    let query = `sales/orderedItems?type=${this.selectedList}`;

    if (this.startDate) query += `&start_date=${this.startDate}`;
    if (this.endDate) query += `&end_date=${this.endDate}`;
    if (this.searchTerm) query += `&searchTerm=${this.searchTerm}`;
if (this.statusFilter !== null) query += `&status=${this.statusFilter}`;

    ApiService.get(query)
      .then((response) => {
        this.salesOrders = response.data;
      })
      .catch((error) => {
        console.error("Error fetching sales orders:", error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
   filterStatuses() {
    const filtered = this.rawStatuses.filter((status) => {
      switch (this.selectedList) {
        case "active":
          return !["revoked", "closed"].includes(status.value);
        case "inactive":
          return ["revoked", "closed"].includes(status.value);
        case "contracted":
          return status.value === "contracted";
        case "lost":
          return ["offer_approval", "offer_done","order_approval","ordered"].includes(status.value);
        default:
          return true;
      }
    });


  this.statuses = [
    { key: null, value: this.$t("FORMS.select") }, // zero element
  ...filtered.map((status) => ({
    key: status.key, // numeric key stays
    value: this.$t(`SALESORDERSSTATUSES.${status.value}`),
  })),
];
  }
  },

  watch: {
    selectedList() {
    this.statusFilter = null;
    this.fetchSalesOrders();
    this.filterStatuses(); // re-filter whenever selectedList changes
  },
  startDate() { this.fetchSalesOrders(); },
  endDate() { this.fetchSalesOrders(); },
  searchTerm() { this.fetchSalesOrders(); },
  statusFilter() { this.fetchSalesOrders(); },
  },
};
</script>

<style scoped>
.v-card-title {
  align-items: center;
}
</style>
